// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.calendar-brigade__filter {
  margin-top: 15px;
  display: flex;
}
.calendar-brigade__filter-item {
  width: auto;
  height: 30px;
  border: 1px solid #212529;
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.calendar-brigade__filter-item:active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff;
}
.calendar-brigade__filter-item.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff;
}
@media (max-width: 460px) {
  .calendar-brigade__filter-item {
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.calendar-brigade__filter-newProject {
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
@media (max-width: 460px) {
  .calendar-brigade__filter-newProject {
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}
.calendar-brigade__dropdown {
  position: relative;
}
@media (max-width: 460px) {
  .calendar-brigade__dropdown {
    margin-top: 10px;
  }
}
.calendar-brigade__dropdown-brigade {
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
@media (max-width: 460px) {
  .calendar-brigade__dropdown-brigade {
    height: 20px;
    font-size: 10px;
  }
}
.calendar-brigade__dropdown-modal {
  position: absolute;
  width: 240px;
  height: auto;
  border: 2px solid #212529;
  background-color: #ffffff;
  padding: 7px;
  z-index: 5;
}
@media (max-width: 460px) {
  .calendar-brigade__dropdown-modal {
    width: 180px;
  }
}
.calendar-brigade__dropdown-item {
  font-size: 16px;
  color: #212529;
  font-weight: 500;
  cursor: pointer;
}
.calendar-brigade__dropdown-item:hover {
  font-weight: 700;
}
@media (max-width: 460px) {
  .calendar-brigade__dropdown-item {
    font-size: 13px;
  }
}
.calendar-brigade__table {
  width: 50%;
}
@media (max-width: 460px) {
  .calendar-brigade__table {
    width: 100%;
  }
}
.calendar-brigade__month {
  margin-top: 15px;
  display: flex;
}
.calendar-brigade__month-arrow img {
  width: 25px;
  height: 25px;
  cursor: pointer;
}
.calendar-brigade__month-name {
  font-size: 18px;
  font-weight: 400;
  padding: 0px 7px 0px 7px;
}

.gant-brigade__container {
  position: relative;
  margin-top: 20px;
  overflow: hidden;
  height: calc(100vh - var(--header-height, 150px));
}
@media (max-width: 768px) {
  .gant-brigade__container {
    height: calc(100vh - var(--header-height, 250px));
  }
}
.gant-brigade__table {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #dee2e6;
  overscroll-behavior: contain;
}
.gant-brigade__table-th {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: #ffffff !important;
}
.gant-brigade__table-th::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  border-right: solid 1px #dee2e6;
  border-bottom: solid 1px #dee2e6;
}
.gant-brigade-th.mobile {
  padding: 5px !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: #ffffff !important;
  text-align: center;
}
.gant-brigade-th.mobile::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  border-bottom: 2px solid #dee2e6;
  width: 100%;
}
.gant-brigade-td.mobile {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
@media (max-width: 1024px) {
  .gant-brigade-td.mobile {
    background-color: #ffffff !important;
  }
}
.gant-brigade-td.mobile {
  content: "";
  position: absolute;
  top: 0;
  right: 0px;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.new-project__title {
  font-size: 18px;
  color: #000000;
  font-weight: 500;
}

.new-project__item {
  font-size: 17px;
  color: #000000;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/ChangeBrigade/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEZ;EACI,gBAAA;EACA,aAAA;AAAR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA,EAAA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAAZ;AACY;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA;AAChB;AAEY;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA;AAAhB;AAGY;EArBJ;IAsBQ,YAAA;IACA,eAAA;IACA,iBAAA;EAAd;AACF;AAGQ;EACI,YAAA;EACA,yBAAA;EACA,yBAAA,EAAA,mCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AADZ;AAEY;EAVJ;IAWQ,YAAA;IACA,eAAA;IACA,iBAAA;EACd;AACF;AAKI;EACI,kBAAA;AAHR;AAIQ;EAFJ;IAGQ,gBAAA;EADV;AACF;AAEQ;EACI,YAAA;EACA,yBAAA;EACA,yBAAA,EAAA,mCAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAAZ;AACY;EATJ;IAUQ,YAAA;IACA,eAAA;EAEd;AACF;AACQ;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;AACZ;AAAY;EARJ;IASQ,YAAA;EAGd;AACF;AAGQ;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AADZ;AAEY;EACI,gBAAA;AAAhB;AAEY;EARJ;IASQ,eAAA;EACd;AACF;AAGI;EAEI,UAAA;AAFR;AAGQ;EAHJ;IAIQ,WAAA;EAAV;AACF;AAGI;EACI,gBAAA;EACA,aAAA;AADR;AAIY;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAFhB;AAMQ;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;AAJZ;;AAWI;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;AARR;AASQ;EALJ;IAMQ,iDAAA;EANV;AACF;AAQI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,yBAAA;EACA,4BAAA;AANR;AAQQ;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,oCAAA;AANZ;AAUQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,gCAAA;AARZ;AAaI;EACI,uBAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;AAXR;AAcI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;AAZR;AAeI;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AAbR;AAcQ;EALJ;IAMQ,oCAAA;EAXV;AACF;AAcI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAZR;;AAkBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAfJ;;AAkBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAfJ","sourcesContent":[".calendar-brigade {\n   \n    &__filter {\n        margin-top: 15px;\n        display: flex;\n\n        &-item {\n            width: auto;\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #ffffff; /* Белый фон для неактивной кнопки */\n            color: #212529; \n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            margin-right: 10px;\n            &:active {\n                background-color: #212529; /* Черный фон для активной кнопки */\n                color: #ffffff;\n               \n              }\n            &.active {\n                background-color: #212529; /* Черный фон для активной кнопки */\n                color: #ffffff;\n            }\n\n            @media(max-width: 460px) {\n                height: 20px;\n                font-size: 10px;\n                margin-right: 5px;\n            }\n        }\n\n        &-newProject {\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; \n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            margin-right: 10px;\n            @media(max-width: 460px) {\n                height: 20px;\n                font-size: 10px;\n                margin-right: 5px;\n            }\n        }\n\n        \n    }\n\n    &__dropdown {\n        position: relative;\n        @media(max-width: 460px) {\n            margin-top: 10px;\n        }\n        &-brigade {\n            height: 30px;\n            border: 1px solid #212529;\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; \n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            @media(max-width: 460px) {\n                height: 20px;\n                font-size: 10px;\n            }\n        }\n\n        &-modal {\n            position: absolute;\n            width: 240px;\n            height: auto;\n            border: 2px solid #212529;\n            background-color: #ffffff;\n            padding: 7px;\n            z-index: 5;\n            @media(max-width: 460px) {\n                width: 180px;\n                \n                \n                \n            }\n        }\n\n        &-item {\n            font-size: 16px;\n            color: #212529;\n            font-weight: 500;\n            cursor: pointer;\n            &:hover {\n                font-weight: 700;\n            }\n            @media(max-width: 460px) {\n                font-size: 13px;\n            }\n        }\n    }\n\n    &__table {\n        \n        width: 50%;\n        @media(max-width: 460px) {\n            width: 100%;\n        }\n    }\n\n    &__month {\n        margin-top: 15px;\n        display: flex;\n\n        &-arrow {\n            img {\n                width: 25px;\n                height: 25px;\n                cursor: pointer;\n            }\n        }\n\n        &-name {\n            font-size: 18px;\n            font-weight: 400;\n            padding: 0px 7px 0px 7px;\n        }\n    }\n}\n\n//gant-brigade \n.gant-brigade {\n    &__container {\n        position: relative;\n        margin-top: 20px; \n        overflow: hidden;\n        height: calc(100vh - var(--header-height, 150px));\n        @media(max-width: 768px) {\n            height: calc(100vh - var(--header-height, 250px));\n        }\n    }\n    &__table {\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n        border: 1px solid #dee2e6;\n        overscroll-behavior: contain;\n\n        &-th {\n            padding: 5px !important;\n            position: sticky;\n            left: 0;\n            top: 0;\n            z-index: 3;\n            background-color: #ffffff !important;\n           \n        }\n\n        &-th::after {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            right: 0;\n            height: 100%;\n            width: 100%;\n            border-right: solid 1px #dee2e6;\n            border-bottom: solid 1px #dee2e6;\n          \n        }\n    }\n\n    &-th.mobile {\n        padding: 5px !important;\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 4;\n        background-color: #ffffff !important; \n        text-align: center;\n    }\n\n    &-th.mobile::after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n        height: 100%;\n        border-bottom: 2px solid #dee2e6;\n        width: 100%;\n    }\n\n    &-td.mobile {\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n        @media(max-width: 1024px) {\n            background-color: #ffffff !important;\n        }\n    }\n\n    &-td.mobile {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0px;\n        width: 1px;\n        height: 100%;\n        background-color: #dee2e6;\n    }\n}\n\n//ModalNewProject\n\n.new-project__title {\n    font-size: 18px;\n    color: #000000;\n    font-weight: 500;\n}\n\n.new-project__item {\n    font-size: 17px;\n    color: #000000;\n    font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
